// extracted by mini-css-extract-plugin
export default {"wrapper":"Analytics_wrapper__WE+Dg","container":"Analytics_container__tmLf2","upgradeBtn":"Analytics_upgradeBtn__Cq5rj"};